import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components

import { BaseDescription } from './BaseDescription';
import { AccumulatorDescription } from './AccumulatorDescripton';
import ProgressBar from '../ProgressBar';
import { humanizeAccumulatorInfo, accumulatorsUnits } from '../../../util';

import { accumulatorShape } from '../../../../propTypes';

// Styles
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const OptionAccumulator = ({
  value,
  description,
  operationType,
  accumulatorType,
  accumulatorData,
}) => (accumulatorData && accumulatorType?.charged ? (
  <div className={cx('option-accumulator')}>
    <ProgressBar
      bg={accumulatorType.color}
      percent={(accumulatorType.rest * 100) / accumulatorType.size}
      legend={humanizeAccumulatorInfo(accumulatorType.rest, accumulatorsUnits[operationType])}
    />
    <AccumulatorDescription accumulatorType={accumulatorType} description={description} />
  </div>
) : (
  <BaseDescription value={value} description={description} />
));

OptionAccumulator.propTypes = {
  value: PropTypes.string,
  operationType: PropTypes.string,
  description: PropTypes.string,
  accumulatorType: accumulatorShape,
  accumulatorData: PropTypes.arrayOf(accumulatorShape),
};

export { OptionAccumulator };
